module.exports = __webpack_public_path__ + "img/fenxiangerweima.0fab01ee.png";